<template>
  <footer class="footer bg-light">
    <div class="container">
      <div class="row py-5">
        <div class="col-md-3 mb-4 mb-md-0">
          <h5 class="fw-bold mb-4">{{ $t('appName') }}</h5>
          <p class="text-muted mb-0">
            © {{ currentYear }} {{ $t('company') }}. {{ $t('footer.allRightsReserved') }}
          </p>
        </div>
        <div class="col-md-3 mb-4 mb-md-0">
          <h5 class="fw-bold mb-4">{{ $t('footer.contactUs') }}</h5>
          <ul class="list-unstyled mb-0">
            <li class="mb-3">
              <i class="bi bi-envelope me-2"></i>
              <a href="mailto:support@qinfu-cloud.cn" class="text-muted text-decoration-none">support@qinfu-cloud.cn</a>
            </li>
          </ul>
        </div>
        <div class="col-md-3 mb-4 mb-md-0">
          <h5 class="fw-bold mb-4">{{ $t('footer.quickLinks') }}</h5>
          <ul class="list-unstyled mb-0">
            <li class="mb-3">
              <router-link to="/privacy" class="text-muted text-decoration-none">
                {{ $t('footer.privacy') }}
              </router-link>
            </li>
            <li class="mb-3">
              <router-link to="/support" class="text-muted text-decoration-none">
                {{ $t('nav.support') }}
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="text-muted text-decoration-none">
                {{ $t('footer.contactUs') }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-3 text-center">
          <h5 class="fw-bold mb-4">{{ $t('footer.wechat') }}</h5>
          <img src="@/assets/gongzhonghao.jpg" alt="微信公众号" class="wechat-qr mb-3">
          <p class="text-muted small">{{ $t('footer.scanQR') }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  border-top: 1px solid var(--color-border);
  padding: var(--spacing-2xl) 0;
  margin-top: var(--spacing-3xl);
  position: relative;
  bottom: 0;
  width: 100%;
  background: var(--color-surface);
}

.footer h5 {
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-bottom: var(--spacing-sm);
}

.footer p {
  font-size: 15px;
  line-height: 1.6;
  color: var(--color-text-secondary);
}

.footer ul li {
  font-size: 15px;
  line-height: 1.6;
}

.footer a {
  color: var(--color-text-secondary);
  transition: color 0.2s ease;
}

.footer a:hover {
  color: var(--color-primary) !important;
}

.footer .bi {
  color: var(--color-primary);
  font-size: 18px;
}

.wechat-qr {
  width: 150px;
  height: 150px;
  border-radius: 12px;
  border: 2px solid var(--color-border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.wechat-qr:hover {
  transform: scale(1.05);
}

@media (max-width: 734px) {
  .footer {
    padding: var(--spacing-md) 0;
    margin-top: var(--spacing-xl);
  }
}
</style>

